import ReactOnRails from 'react-on-rails';
import UpdateStripeInfoApp from './appClient';

// This is how react_on_rails can see the HelloWorldApp in the browser.
ReactOnRails.register({ UpdateStripeInfoApp });
